/**
 * @desc EditUserRoles
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.EditUserRoles,
): Promise<defs.StandardReturn> {
  return defHttp.post({
    url: '/web/user/updateRole',
    data,
  });
}

export function mock(data: defs.EditUserRoles): Promise<defs.StandardReturn> {
  return defHttp.post({
    url: '/mock/web/user/updateRole',
    data,
  });
}
